import gql from 'graphql-tag';
import fragments from '../fragments';

export default {
    updateTagMutation: gql`
        mutation UpdateTag($id: String!, $name: String!, $color: String!) {
            updateTag(tag: { id: $id, name: $name, color: $color }) {
                _
            }
        }
    `,
};
